<template>
  <div class="w-full bg-legal">
    <div class="py-20 px-4 lg:px-24">
      <h1 class="font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28">Complaints</h1>
    </div>
  </div>

  <div class="bg-white">
    <div class="pl-4 lg:pl-20 py-14 font-poppins">
      <div>
        <h3 class="font-poppins-bold text-lg">MAKING A COMPLAINT</h3>
        <p class="text-base">If your issue has not been resolved by our Support Team, you are entitled to lodge a complaint.</p>

        <p class="text-base">You can do so by the following means:</p>

        <p class="text-base">Email: complaints@nexee.au</p>
        <p class="text-base">Mail: Suite 1, Level 16, 323 Castlereagh Street, Haymarket NSW 2000</p>

        <p class="text-base">National Relay Service: TTY/Voice 133 677 | Speak & Listen 1300 555 727</p>

        <p class="text-base">To view our complaints response times and process, please refer to our <a href="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/complaints-handling-process.pdf">Complaint Handling Process</a></p>

        <p class="text-base">If requested, we will help you with formulating, lodging and progressing your complaint. This may be necessary for consumers with a disability, those who are suffering financial hardship or are from a non-English speaking background.</p>

        <h3 class="font-poppins-bold text-lg pt-4">TELECOMMUNICATIONS INDUSTRY OMBUDSMAN (TIO)</h3>
        <p class="text-base">We encourage you to always contact Nexee first if you experience any problem or are unhappy. We will do our best to solve your problem during our first contact.</p>

        <p class="text-base">At any time, you can contact the Telecommunications Industry Ombudsman (TIO) for assistance. The TIO is a free, independent service that helps with phone and internet complaints. The TIO may be able to assist you where you are unhappy with the information we have given you, the time it takes for us to respond, or the way we respond.</p>

        <p class="text-base">The information below can be used to find out more about how the TIO can assist you or to contact the TIO.</p>

        <p class="text-base">Phone: 1800 062 058</p>
        <p class="text-base">Webpage: <a href="https://www.tio.com.au/complaints/what-we-can-help-with">What we can help with</a></p>
        <p class="text-base">Online: <a href="https://www.tioonline.com.au/?_gl=1*vnzrdd*_ga*MTEzNTA2MTI5Mi4xNzI5MDU0NTI4*_ga_HGR8J15431*MTcyOTA1NDUyNy4xLjEuMTcyOTA1NDkzNi42MC4wLjA.">Online Complaint Form</a></p>
        <p class="text-base">Email: tio@tio.com.au </p>
        <p class="text-base">Fax: 1800 630 614</p>

       <p class="text-base">Access using a language interpreter, Auslan interpreter or the National Relay Service - 'Interpreters and accessibility' webpage.</p>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();
</script>
<style scoped>
.bg-legal {
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/legal-bg.png");
  background-position: center center;
  background-size: cover;
  height: 100%;
}
</style>
